import type { EventResultsPayload, TeamResult } from "../api/client";

/** ຜົນຕາມຮາງ — ພຽງຕາຕາລາງ ຮອບສຸດທ້າຍ (ຄູ່ແຂ່ງປັດຈຸບັນ) ໃຊ້ dashboard / ສະຫຼຸບທີມ. */
export function flattenEventTeamResults(
  data: EventResultsPayload | undefined,
): TeamResult[] {
  return (
    data?.divisions.flatMap((d) => {
      const last = d.rounds[d.rounds.length - 1];
      return last?.teams ?? [];
    }) ?? []
  );
}

/** ທຸກແຖວຜົນ (ຮາງ × ຮອບ) — ໃຊ້ນັບວ່າມີຄະແນນຫຼື export ເມື່ອຕ້ອງການຄົບທຸກຮອບ. */
export function flattenAllRoundResults(
  data: EventResultsPayload | undefined,
): TeamResult[] {
  return data?.divisions.flatMap((d) => d.rounds.flatMap((r) => r.teams)) ?? [];
}
